import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { WBTypography, WBIconButton, WBFlex } from '@admiin-com/ds-web';

export const ModalLayout = ({
  open,
  onClose,
  title,
  children,
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      <DialogTitle variant="h1">
        <WBFlex justifyContent="space-between" alignItems="center">
          <WBTypography variant="h1">{title}</WBTypography>
          <WBIconButton icon="Close" onClick={onClose} />
        </WBFlex>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};
